import { AuditEntity } from "@app/common";
import { Cost } from "@app/core";
import { Column, Display, prop, propArray, required, Table } from "@messaia/cdk";
import { TariffChangeType } from "../enums/tariff-change-type";
import { TariffChangeBundleProductEquivalence } from "./tariff-change-bundle-product-quivalences";

@Table({
    endpoint: 'tariffchange',
    includes: ['FromTariff', 'ToTariff', 'Client']
})
export class TariffChange extends AuditEntity {
    @Column({ name: 'type', enumType: TariffChangeType, maxWidth: 80 })
    @Display($localize`:@@type:Type`)
    @required()
    type: TariffChangeType;

    @Column({ name: 'fromTariff.nameIntern', filter: 'fromTariff.nameIntern' })
    @Display($localize`:@@fromTariff:From tariff`)
    @required()
    fromTariffId: number | null;

    @Column({ name: 'toTariff.nameIntern', filter: 'toTariff.nameIntern', showGtLg: true })
    @Display($localize`:@@toTariff:To tariff`)
    @required()
    toTariffId: number | null;

    @Column({ name: 'client.name', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 250, showGtXl: true })
    @Display($localize`:@@client:Client`)
    @required()
    clientId: number;

    @Column({ event: 'toggle' })
    @Display($localize`:@@enabled:Enabled`)
    @prop()
    enabled: boolean = true;

    @required()
    minTerm: number = 0;

    @required()
    maxTerm: number = 12;

    @propArray(Cost)
    costs: Cost[] = [];

    @propArray(TariffChangeBundleProductEquivalence)
    bundleProductEquivalences: TariffChangeBundleProductEquivalence[] = [];

    /**
     * constructor
     * @param init 
     */
    public constructor(init?: Partial<TariffChange>) {
        super(init);
        Object.assign(this, init);
    }
}